module.exports = __webpack_public_path__ + "static/media/filter.07deb708.svg";